import { Box,  Dialog,  IconButton,  List, ListItem, ListItemButton, ListItemText } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import { blobSAS } from '../Helper/BlobHelper'
import Service from '../Networking/NetworkingUtils'
import { getCookie } from '../Utils/CookieHelper'
import { useSnackbar } from "notistack";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';


var token = getCookie("bb_metaverse_token");


const VideoVersionList = (props) => {

    const [url, setUrl] = useState(null);
    const [videoDialog, setVideoDialog] = useState(false);
    const [data, setData] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const playerRef = useRef(null);
    const [sasToken, setSasToken] = useState(null);

    const handleVideoDialog = () => {
        setVideoDialog(false)
    }

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        let isMounted = true;

        const loadSasToken = async () => {
            const tokenData = await blobSAS({ token_type: 'read_only', container_name: 'project-executables' });
            if (isMounted) {
                setSasToken(tokenData);
            }
        };

        loadSasToken();

        return () => {
            isMounted = false;
        };
    }, []);

    const handleReady = () => {
        // This ensures metadata is loaded before attempting PiP
        if (playerRef.current && playerRef.current.getInternalPlayer()) {
          playerRef.current.getInternalPlayer().requestPictureInPicture().catch(error => {
            console.error("Failed to request Picture-in-Picture:", error);
          });
        }
      };

    function getData() {
        Service.get(`/api/asset/version/get_version_by_project/?project_asset=${props.data.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            setData(res.data)

        }).catch(error => {
            console.log(error);
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
        })
    }

    return (
        <div>
            <div>
                <List dense={true} sx={{ py: 0.5 }}>
                    {data.map((data, index) => {
                        return (
                            <ListItemButton
                                key={data.id || index}
                                onClick={() => { setVideoDialog(true); setUrl(data.asset_source); }}
                                sx={{
                                    mx: 0.5,
                                    borderRadius: 1,
                                    position: 'relative',
                                    '&:hover': {
                                        backgroundColor: 'rgba(25, 118, 210, 0.06)',
                                    },
                                    '&::after': {
                                        content: '""',
                                        position: 'absolute',
                                        left: 16,
                                        right: 16,
                                        bottom: 0,
                                        height: '1px',
                                        backgroundColor: 'rgba(0, 0, 0, 0.22)',
                                    },
                                }}
                            >
                                <ListItem>
                                    <ListItemText
                                        primary={data.version}
                                        secondary={data.change_log ? data.change_log : null}
                                    />
                                </ListItem>
                            </ListItemButton>
                        )
                    })}
                </List>
            </div>
            <Dialog fullWidth={true} maxWidth="md" open={videoDialog} onClose={handleVideoDialog}>
                <Box sx={{display:'flex',justifyContent:'center', alignItems:'center'}}>
                <Box sx={{m:2}}>
                <ReactPlayer 
                    url={sasToken ? sasToken.fd_account_url + url + "?" + sasToken.read_only?.['project-executables'].sas_token : ''}
                    controls={true} pip={true} stopOnUnmount={false} 
                    width="500" height="500"
                    onReady={handleReady}
                    playing
                    playIcon={<IconButton><PlayArrowIcon color="primary" sx={{ fontSize: 120 }} /></IconButton>}
                    config={{
                        file: {
                            attributes: {
                                controlsList: 'nodownload',
                                onContextMenu: e => e.preventDefault()
                            }
                        }
                    }}
                />
                </Box>
                </Box>
            </Dialog>
        </div>
    )
}

export default VideoVersionList